export const topicWall = [
  { name: "宿舍矛盾", count: 1286, hot: true },
  { name: "表白墙风波", count: 942, hot: true },
  { name: "考试争议", count: 731 },
  { name: "校园霸凌", count: 512, hot: true },
  { name: "班主任回应", count: 455 },
  { name: "处分公告", count: 466 },
  { name: "课堂纪律", count: 604 },
  { name: "社团经费", count: 388 },
  { name: "家长群截图", count: 349 },
  { name: "走廊冲突", count: 305 },
  { name: "手机管理", count: 296 },
  { name: "校园恋情", count: 277 },
  { name: "宿舍查寝", count: 240 },
  { name: "体育比赛冲突", count: 218 },
  { name: "奖学金评定", count: 193 },
  { name: "校内传闻", count: 189 },
];

export const schoolResponses = [
  {
    school: "市第七中学 · 教务处",
    quote:
      "已成立专项工作小组，对相关同学进行心理疏导，并对涉事班级开展常规纪律教育，后续进展将及时向家长通报。",
    date: "2026-09-08",
    status: "已公开",
  },
  {
    school: "明德实验中学 · 学生处",
    quote:
      "经核实，网传部分聊天截图存在拼接情况，请同学们以学校官方通报为准，不传播未经证实的信息。",
    date: "2026-09-06",
    status: "已公开",
  },
  {
    school: "滨河职业技术学院 · 学工处",
    quote:
      "已联系当事同学及家长沟通，事情正在按校规流程处理，感谢同学与家长对校园秩序的关注。",
    date: "2026-09-03",
    status: "跟进中",
  },
];

export const chatGroups = [
  {
    group: "高二（3）班 · 班级群",
    meta: "47 人 · 截图由同学提供",
    messages: [
      { name: "班长", text: "自习课调到下午第二节，大家记得带练习册。", own: false },
      { name: "同学 K", text: "今晚走廊那事儿到底真的假的啊？", own: false },
      { name: "同学 M", text: "别在群里传了，等老师统一说明吧。", own: true },
    ],
  },
  {
    group: "18 栋 402 宿舍群",
    meta: "6 人 · 截图由同学提供",
    messages: [
      { name: "舍友 A", text: "熄灯之后能不能小声点，明天还要早读。", own: false },
      { name: "舍友 C", text: "有事白天说，别在群里阴阳怪气。", own: false },
      { name: "同学 M", text: "已经跟宿管反映了，大家冷静一下。", own: true },
    ],
  },
  {
    group: "高三年级组 · 家长群",
    meta: "212 人 · 截图由家长提供",
    messages: [
      { name: "家长 L", text: "请问周五的通报是学校正式发的吗？", own: false },
      { name: "班主任", text: "以学校公众号为准，请勿转发来路不明的截图。", own: false },
      { name: "家长 W", text: "收到，感谢老师及时说明。", own: true },
    ],
  },
];

export const disciplineItems = [
  {
    title: "宿舍熄灯后争执事件",
    tag: "宿舍矛盾",
    date: "2026-09-09",
    stage: "处理中",
    result: "涉事宿舍已调换床位，等待学生处最终处理意见，当事同学已接受心理疏导。",
  },
  {
    title: "匿名表白墙点名风波",
    tag: "表白墙风波",
    date: "2026-09-07",
    stage: "已回应",
    result: "学校说明截图存在拼接，要求账号运营者删除相关内容并向当事同学说明情况。",
  },
  {
    title: "期末监考争议",
    tag: "考试争议",
    date: "2026-09-05",
    stage: "已处分",
    result: "对违规监考人员作出通报批评，成绩复核流程已完成，结果已向全班公示。",
  },
  {
    title: "社团经费使用质疑",
    tag: "社团经费",
    date: "2026-09-02",
    stage: "已回应",
    result: "社团联合会公开账目明细，经费去向已逐一说明，未发现违规挪用情况。",
  },
  {
    title: "教学楼走廊推挤冲突",
    tag: "走廊冲突",
    date: "2026-08-30",
    stage: "已处分",
    result: "对涉事同学进行批评教育，并按校规给予相应处分，双方已当面沟通和解。",
  },
  {
    title: "手机管理新规相关讨论",
    tag: "手机管理",
    date: "2026-08-27",
    stage: "处理中",
    result: "学校正就代管方案征集同学意见，具体实施细则尚未正式发布。",
  },
];

export const comments = [
  {
    name: "路过的学长",
    initials: "学",
    time: "2 小时前",
    content:
      "这类校园事件最缺的就是时间线。学校回应、同学爆料和处分结果放在一起看，很多误会其实一下就清楚了。",
    likes: 128,
    hot: true,
    replies: [
      {
        name: "同校同学",
        initials: "同",
        content: "确实，截图单独拿出来太容易被带节奏了。",
      },
    ],
  },
  {
    name: "安静的自习课",
    initials: "静",
    time: "4 小时前",
    content: "希望爆料的时候能多打码，别把无关同学也一起卷进来，大家都是学生。",
    likes: 96,
    hot: false,
    replies: [],
  },
  {
    name: "班主任视角",
    initials: "师",
    time: "6 小时前",
    content: "很多班级群聊截图断章取义，完整看完往往和标题完全不同，理性一点比较好。",
    likes: 74,
    hot: false,
    replies: [],
  },
  {
    name: "毕业两年",
    initials: "毕",
    time: "9 小时前",
    content: "校内传闻跟到最后基本都有官方说法，与其急着站队，不如等等消息来源。",
    likes: 51,
    hot: false,
    replies: [],
  },
  {
    name: "宿舍楼住户",
    initials: "住",
    time: "昨天",
    content: "宿舍矛盾那件事我们楼里都在聊，后来学校确实挨个找过相关同学了解情况。",
    likes: 43,
    hot: false,
    replies: [],
  },
  {
    name: "爱看通报的人",
    initials: "报",
    time: "昨天",
    content: "处分结果这块整理得挺细，比零散的截图墙好读多了。",
    likes: 29,
    hot: false,
    replies: [],
  },
];